import { FC } from 'react';
import { WarrantyFaq } from './WarrantyFaq/WarrantyFaq';

export const WarrantyFaqPage: FC = () => {
  return <WarrantyFaq />;
};
